var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.products, function (product) {
        return _vm.totalPrice[product.id] ||
          _vm.hasSingleUpgrade(product.id) ||
          _vm.leaseProlongPrice[product.id] ||
          _vm.hasSubscriptionPromo(product.id) ||
          _vm.totalSubscription[product.id]
          ? _c("div", [
              _c("div", { staticClass: "summary__block" }, [
                _c("div", { staticClass: "summary__block--title" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "images/" +
                        product.name.replace(" ", "").toLowerCase() +
                        "_gray.png",
                      alt: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(product.name))]),
                ]),
                _vm._v(" "),
                _vm.totalSubscription[product.id]
                  ? _c(
                      "div",
                      { staticClass: "summary__block--item" },
                      [
                        _vm.showMaintenanceCheckbox
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "scrollTo",
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.scrollTo(product, "lease")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getTranslation(
                                        "cart-vue",
                                        "new_leases"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          : [
                              _vm._v(
                                _vm._s(
                                  _vm.getTranslation("cart-vue", "new_leases")
                                )
                              ),
                            ],
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.priceFormat(
                                _vm.totalSubscription[product.id],
                                false,
                                true
                              )
                            )
                          ),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.totalPerpetual[product.id]
                  ? _c(
                      "div",
                      { staticClass: "summary__block--item" },
                      [
                        _vm.showMaintenanceCheckbox
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "scrollTo",
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.scrollTo(product, "perpetual")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getTranslation(
                                        "cart-vue",
                                        "new_perpetual"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          : [
                              _vm._v(
                                _vm._s(
                                  _vm.getTranslation(
                                    "cart-vue",
                                    "new_perpetual"
                                  )
                                )
                              ),
                            ],
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.priceFormat(
                                _vm.totalPerpetual[product.id],
                                false,
                                true
                              )
                            )
                          ),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.totalPerpetualUpgrade[product.id]
                  ? _c("div", { staticClass: "summary__block--item" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.getTranslation("cart-vue", "perpetual_upgrade")
                          ) +
                          "\n                "
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.priceFormat(
                              _vm.totalPerpetualUpgrade[product.id],
                              false,
                              true
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasSingleUpgrade(product.id)
                  ? _c(
                      "div",
                      { staticClass: "summary__block--item" },
                      [
                        _vm.showMaintenanceCheckbox
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "custom-control custom-checkbox b-custom-control-lg labelPrice",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.singleUpgradeProductStatus[
                                          product.id
                                        ],
                                      expression:
                                        "singleUpgradeProductStatus[product.id]",
                                    },
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "checkbox",
                                    name: "singleUpgrade[" + product.id + "]",
                                    id: "singleUpgradeCartToggle_" + product.id,
                                  },
                                  domProps: {
                                    value: product.id,
                                    checked: Array.isArray(
                                      _vm.singleUpgradeProductStatus[product.id]
                                    )
                                      ? _vm._i(
                                          _vm.singleUpgradeProductStatus[
                                            product.id
                                          ],
                                          product.id
                                        ) > -1
                                      : _vm.singleUpgradeProductStatus[
                                          product.id
                                        ],
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleSingleUpgrade(product.id)
                                    },
                                    change: function ($event) {
                                      var $$a =
                                          _vm.singleUpgradeProductStatus[
                                            product.id
                                          ],
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = product.id,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.singleUpgradeProductStatus,
                                              product.id,
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.singleUpgradeProductStatus,
                                              product.id,
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.singleUpgradeProductStatus,
                                          product.id,
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "custom-control-label d-flex flex-wrap",
                                    attrs: {
                                      for:
                                        "singleUpgradeCartToggle_" + product.id,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.getTranslation(
                                            "cart-vue",
                                            "single_upgrade"
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.priceFormat(
                                        _vm.singleUpgradePrice[product.id],
                                        true,
                                        true
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.showMaintenanceCheckbox
                          ? [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.getTranslation(
                                      "cart-vue",
                                      "single_upgrade"
                                    )
                                  ) +
                                  "\n                    "
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.priceFormat(
                                      _vm.singleUpgradePrice[product.id],
                                      true,
                                      true
                                    )
                                  )
                                ),
                              ]),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.leaseProlongPrice[product.id] && 0
                  ? _c("div", { staticClass: "summary__block--item" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getTranslation("cart-vue", "lease_prolongation")
                        ) + " "
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.priceFormat(
                              _vm.leaseProlongPrice[product.id],
                              false,
                              true
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.totalSubscriptionCustomization[product.id] && 0
                  ? _c("div", { staticClass: "summary__block--item" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.getTranslation(
                              "cart-vue",
                              "subscription_customization"
                            )
                          ) +
                          "\n                "
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.priceFormat(
                              _vm.totalSubscriptionCustomization[product.id],
                              false,
                              true
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.canPurchaseMaintenance(product.id)
                  ? _c(
                      "div",
                      { staticClass: "summary__block--item" },
                      [
                        _vm.showMaintenanceCheckbox
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "custom-control custom-checkbox b-custom-control-lg labelPrice",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.$store.state.cart.maintenance[
                                          product.id
                                        ].status,
                                      expression:
                                        "$store.state.cart.maintenance[product.id].status",
                                    },
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "checkbox",
                                    name: "maintenance[" + product.id + "]",
                                    id: "maintenanceCartToggle_" + product.id,
                                  },
                                  domProps: {
                                    value: product.id,
                                    checked: Array.isArray(
                                      _vm.$store.state.cart.maintenance[
                                        product.id
                                      ].status
                                    )
                                      ? _vm._i(
                                          _vm.$store.state.cart.maintenance[
                                            product.id
                                          ].status,
                                          product.id
                                        ) > -1
                                      : _vm.$store.state.cart.maintenance[
                                          product.id
                                        ].status,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleMaintenance(product.id)
                                    },
                                    change: function ($event) {
                                      var $$a =
                                          _vm.$store.state.cart.maintenance[
                                            product.id
                                          ].status,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = product.id,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.$store.state.cart.maintenance[
                                                product.id
                                              ],
                                              "status",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.$store.state.cart.maintenance[
                                                product.id
                                              ],
                                              "status",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.$store.state.cart.maintenance[
                                            product.id
                                          ],
                                          "status",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "custom-control-label d-flex flex-wrap",
                                    attrs: {
                                      for:
                                        "maintenanceCartToggle_" + product.id,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.getTranslation(
                                            "cart-vue",
                                            "maintenance"
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.priceFormat(
                                          _vm.totalMaintenance(product.id),
                                          true,
                                          true
                                        )
                                      )
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.showMaintenanceCheckbox
                          ? [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.getTranslation(
                                      "cart-vue",
                                      "maintenance"
                                    )
                                  ) +
                                  "\n                    "
                              ),
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.priceFormat(
                                        _vm.totalMaintenance(product.id),
                                        true,
                                        true
                                      )
                                    )
                                ),
                              ]),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.volumeDiscount[product.id]
                  ? _c("div", { staticClass: "summary__block--item" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getTranslation("cart-vue", "volume_discount")
                        ) + " "
                      ),
                      _c("span", [
                        _vm._v(
                          " - " +
                            _vm._s(
                              _vm.priceFormat(
                                _vm.volumeDiscount[product.id],
                                false,
                                true
                              )
                            )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.maintenanceDiscount[product.id]
                  ? _c("div", { staticClass: "summary__block--item" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getTranslation("cart-vue", "maintenance_discount")
                        ) + " "
                      ),
                      _c("span", [
                        _vm._v(
                          " - " +
                            _vm._s(
                              _vm.priceFormat(
                                _vm.maintenanceDiscount[product.id],
                                false,
                                true
                              )
                            )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasSubscriptionPromo(product.id)
                  ? _c("div", { staticClass: "summary__block--item" }, [
                      _vm._v(
                        "\n\n                " +
                          _vm._s(
                            _vm.getTranslation(
                              "promo2025",
                              "subscription_promo_cart_title"
                            )
                          ) +
                          "\n                "
                      ),
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.priceFormat(0, true, true))),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.totalHardlocks || _vm.delivery || _vm.promoCode
        ? _c("div", { staticClass: "summary__block" }, [
            _vm.totalHardlocks
              ? _c("div", { staticClass: "summary__block--item" }, [
                  _vm._v(
                    _vm._s(_vm.getTranslation("cart-vue", "hardlocks")) + " "
                  ),
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.priceFormat(_vm.totalHardlocks, false, true))
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.delivery
              ? _c("div", { staticClass: "summary__block--item" }, [
                  _vm._v(
                    _vm._s(_vm.getTranslation("cart-vue", "delivery")) + " "
                  ),
                  _c("span", [
                    _vm._v(
                      " " + _vm._s(_vm.priceFormat(_vm.delivery, false, true))
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.promoCode
              ? _c("div", { staticClass: "summary__block--item" }, [
                  _vm._v(
                    _vm._s(_vm.getTranslation("cart-vue", "promo_discount")) +
                      " "
                  ),
                  _c("span", [
                    _vm._v(
                      " -" + _vm._s(_vm.priceFormat(_vm.promoCode, false, true))
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "summary__total" }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("span", [_vm._v(_vm._s(_vm.getTranslation("cart-vue", "total")))]),
          _c("span", [
            _vm._v(_vm._s(_vm.priceFormat(_vm.grandTotal, true, true))),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }